import { render, staticRenderFns } from "./ReferralTransactionEarningsTable.vue?vue&type=template&id=1373ab3f&"
import script from "./ReferralTransactionEarningsTable.vue?vue&type=script&lang=js&"
export * from "./ReferralTransactionEarningsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VIcon,VRow})
